<template>
  <div class="my_text_align_layer">
    <div :class="type == 'one_level' ? 'set_one_level': 'set_two_level'">
      <span v-text="title" class="title" v-if="title !== ''" :style="{
      width: titleWidth+ 'px'
     }"></span>
      <div class="text_align_wrapper" style="vertical-align: middle;">
        <div class="selects jz-select jz-select-single" @click="textAlignDialogIsShow=!textAlignDialogIsShow"
          ref="text_align_dialog">
          <div class="jz-select-selection">
            <i class="jz-select-arrow" :class="textAlignDialogIsShow ? 'jz-select-trigger-arrow' : ''"></i>
          </div>
          <div v-if="textAlignDialogIsShow" class="jz-select-dropdown"
            style="overflow: hidden; transform-origin: center top; position: absolute; top: 27px; left: -26px;"
            x-placement="bottom">
            <ul class="jz-select-dropdown-list">
              <div class="jz_scrollbar" style="max-height: 185px;">
                <div class="jz_scrollbar__wrap"
                  style="margin-right: -17px; margin-bottom: -12px; height: calc(100% + 17px); max-height: 202px;">
                  <div class="jz_scrollbar__resize">
                    <div class="jz_scrollbar__view">
                      <li class="jz-select-item" :class="text_align == 'left' ? 'jz-select-item-selected' : ''"
                        @click="selectTextAlign('left')">
                        <span class="icon list_icon align_left"></span>
                        <span class="text">{{$t('base_kindeditor_all_1503')}}</span>
                      </li>
                      <li class="jz-select-item" :class="text_align == 'center' ? 'jz-select-item-selected' : ''"
                        @click="selectTextAlign('center')">
                        <span class="icon list_icon align_center"></span>
                        <span class="text">{{$t('base_options_config_1683')}}</span>
                      </li>
                      <li class="jz-select-item" :class="text_align == 'right' ? 'jz-select-item-selected' : ''"
                        @click="selectTextAlign('right')">
                        <span class="icon list_icon align_right"></span>
                        <span class="text">{{$t('base_kindeditor_all_1504')}}</span>
                      </li>
                      <li class="jz-select-item" :class="text_align == 'justify' ? 'jz-select-item-selected' : ''"
                        @click="selectTextAlign('justify')">
                        <span class="icon list_icon align_justify"></span>
                        <span class="text" style="text-align: justify;">{{$t('base_kindeditor_all_1505')}}</span>
                      </li>
                    </div>
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </div>
        <span class="icon list_icon list_icon_active" :class="'align_'+text_align"></span>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

  export default {
    name: 'my_text_align_index',
    props: {
      titleWidth: { // 组件的标题
        type: String,
        default: '40'
      },
      title: { // 组件的标题
        type: String,
        default: ''
      },
      type: { // 组件的类型  one_level 一级组件 two_level 二级组件
        type: String,
        default: 'two_level'
      },
      textAlign: {
        type: String,
        default: 'left'
      },
    },
    data () {
      return {
        text_align: this.textAlign,
        textAlignDialogIsShow: false
      }
    },
    mounted () {
      //如果有报错可以写
      this.$nextTick(() => {
        document.addEventListener('click', e => {
          const dom = this.$refs.text_align_dialog;
          if (dom && !dom.contains(e.target)) {
            this.textAlignDialogIsShow = false;
          }
        });
      });
    },
    beforeDestroy () {
      document.removeEventListener('click', e => {
        this.textAlignDialogIsShow = false;
      });
    },
    watch: {
      text_align (val) {
        this.$emit('update:textAlign', val);//双向数据绑定
      },
      'textAlign' (val) {
        this.text_align = val
      }
    },
    computed: {},
    methods: {
      selectTextAlign (val) {
        this.text_align = val
        this.textAlignDialogIsShow = false;
      }
    }
  }
</script>

<style scoped>
  .jz_scrollbar__view {
    width: 100px;
  }

</style>



// WEBPACK FOOTER //
// src/components/my_text_align/index.vue